import { ReactComponent as RightHandAbove } from '../../../assets/hands/right-hand-above.svg';
import { ReactComponent as LeftHandAbove } from '../../../assets/hands/left-hand-above.svg';

interface Props {
    perc: number,
    height: number,
    offset: number,
}

const Hands: React.FC<Props> = ({
    perc, offset, height,
}) => {
    const handStyle: React.CSSProperties = {
        position: 'fixed',
        bottom: -height * (1 - perc),
        height,
        width: 'auto',
    };

    const handsAspectRatio = 421 / 1182;

    return (
        <>
            {(perc > 0) && (
                <LeftHandAbove style={{ ...handStyle, left: offset }} />
            )}
            {(perc > 0) && (
                // eslint-disable-next-line max-len
                <RightHandAbove style={{ ...handStyle, left: window.innerWidth - offset - height * handsAspectRatio }} />
            )}
        </>
    );
};

export default Hands;
